//
// Generated class AccountingJournalGroupConditionTemplate
//

/// <reference path="AccountingJournalGroupConditionTemplate_ManagedObject.ts" />

class AccountingJournalGroupConditionTemplate extends AccountingJournalGroupConditionTemplate_ManagedObject
{

}
